<template>
  <FileUpload
    ownerType="DynamicForm::Answer"
    :ownerId="answer.id"
    :disabled="readOnly"
    v-if="answer"
  />
</template>

<script>
  export default {
    name: "InputFile",
    props: {
      field: Object,
      answer: Object,
      value: String,
      readOnly: Boolean,
    },
    model: {
      prop: "value",
      event: "change",
    },
    mounted() {
      if (!this.answer) {
        setTimeout(() => {
          this.$emit("change", "Look on files");
        }, 500);
      }
    },
  };
</script>

<style lang="scss" scoped></style>
